var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8616 1.35491C17.8616 1.03286 17.7336 0.724004 17.5059 0.496281C17.2782 0.268559 16.9693 0.140625 16.6473 0.140625H2.07586C1.75381 0.140625 1.44495 0.268559 1.21723 0.496281C0.989504 0.724004 0.861572 1.03286 0.861572 1.35491C0.861572 1.67696 0.989504 1.98582 1.21723 2.21354C1.44495 2.44126 1.75381 2.5692 2.07586 2.5692H16.6473C16.9693 2.5692 17.2782 2.44126 17.5059 2.21354C17.7336 1.98582 17.8616 1.67696 17.8616 1.35491Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8616 7.42522C17.8616 7.10317 17.7336 6.79432 17.5059 6.56659C17.2782 6.33887 16.9693 6.21094 16.6473 6.21094H2.07586C1.75381 6.21094 1.44495 6.33887 1.21723 6.56659C0.989504 6.79432 0.861572 7.10317 0.861572 7.42522C0.861572 7.74727 0.989504 8.05613 1.21723 8.28385C1.44495 8.51158 1.75381 8.63951 2.07586 8.63951H16.6473C16.9693 8.63951 17.2782 8.51158 17.5059 8.28385C17.7336 8.05613 17.8616 7.74727 17.8616 7.42522Z",
    fill: "#2E37A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8616 13.4955C17.8616 13.1735 17.7336 12.8646 17.5059 12.6369C17.2782 12.4092 16.9693 12.2812 16.6473 12.2812H9.36157C9.03952 12.2812 8.73067 12.4092 8.50294 12.6369C8.27522 12.8646 8.14729 13.1735 8.14729 13.4955C8.14729 13.8176 8.27522 14.1264 8.50294 14.3542C8.73067 14.5819 9.03952 14.7098 9.36157 14.7098H16.6473C16.9693 14.7098 17.2782 14.5819 17.5059 14.3542C17.7336 14.1264 17.8616 13.8176 17.8616 13.4955Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarIcon);
export default __webpack_public_path__ + "static/media/bar-icon.d11ed22633f5197c3a046a0dcd9da693.svg";
export { ForwardRef as ReactComponent };